export default document.getElementById('app')
